// import { agentsHttp } from '@/lib/api/http-client';

import { MOCK_SMART_START_CARDS } from '../mocks/smart-card.mock';
import { logger } from '@/lib/utils/logger';

/**
 * Input configuration for smart start card
 */
export interface SmartStartCardInput {
  agentId: string;
  prompt?: string;
  options?: Record<string, unknown>;
}

/**
 * Smart start card item representing a quick action
 */
export interface SmartStartCardItem {
  id: string;
  title: string;
  toolName: string;
  disabled: boolean;
  input: SmartStartCardInput;
}

/**
 * Valid springboard tab IDs
 */
export type SpringboardTabId = 'plan' | 'create' | 'scale' | 'deliver';

/**
 * Fetches smart start cards for a specific tab category
 * @param tabId - The springboard tab id (e.g., 'plan', 'create', 'scale', 'deliver')
 * @returns Promise with array of smart start card items
 */
export const getSmartStartCards = (tabId: string): Promise<SmartStartCardItem[]> => {
  try {
    // TODO: Replace with actual API endpoint when available
    // const response = await agentsHttp.instance.get<SmartStartCardItem[]>(
    //   `/api/v1/springboard/${tabId}/smart-start-cards`
    // );
    // return response.data;

    // Mock data - simulating different cards per tab
    return Promise.resolve(getMockSmartStartCards(tabId));
  } catch (error) {
    logger.error(`Failed to fetch smart start cards for tab ${tabId}:`, error);
    return Promise.resolve([]);
  }
};

/**
 * Mock function to simulate API responses
 * This will be removed once the real endpoint is available
 */
const getMockSmartStartCards = (tabId: string): SmartStartCardItem[] => {
  return MOCK_SMART_START_CARDS[tabId] ?? [];
};
